module.exports = __webpack_public_path__ + "doctor_1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/doctors/doctor_1.jpg
// module id = 885
// module chunks = 0